import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from "@reduxjs/toolkit";

import { 
    getStorage, 
    ref, 
    uploadBytesResumable, 
    getDownloadURL, 
    deleteObject 
} from "firebase/storage";

const firestoreAdapter = createEntityAdapter();

const initialState = firestoreAdapter.getInitialState({
    urls: [],
    status: 'idle',
    error: null
});

// Create the file metadata
/** @type {any} */
const metadata = {
    contentType: 'image/png'
};
const metadataPdf = {
    contentType: 'application/pdf'
};

// Thunk functions for add a document image to a collection
export const setFile = createAsyncThunk(
    "firestore/setFile",
    async ({ file, name, folder }) => {
        try {
            // Create a root reference
            const storage = getStorage();

            // Upload file and metadata to the object 'images/mountains.jpg'
            const storageRef = ref(storage, folder + name);
            const uploadTask = uploadBytesResumable(storageRef, file, metadata);

            let promise = await new Promise((resolve, reject) => {
                // Listen for state changes, errors, and completion of the upload.
                uploadTask.on('state_changed',
                    (snapshot) => {}, 
                    (error) => {
                        resolve(false)
                    }, 
                    () => {
                        // Upload completed successfully, now we can get the download URL
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            resolve(downloadURL);
                        });
                    }
                );
            });

            return promise;
        } catch (error) {
            return { error, status: "failed" };
        }
    }
);

// Thunk functions for add a document pdf to a collection
export const setFilePDF = createAsyncThunk(
    "firestore/setFilePDF",
    async ({ file, name, folder, metadata }) => {
        try {
            // Create a root reference
            const storage = getStorage();

            // Upload file and metadata to the object 'images/mountains.jpg'
            const storageRef = ref(storage, folder + name);
            const uploadTask = uploadBytesResumable(storageRef, file, { ...metadataPdf, ...metadata });

            let promise = await new Promise((resolve, reject) => {
                // Listen for state changes, errors, and completion of the upload.
                uploadTask.on('state_changed',
                    (snapshot) => {}, 
                    (error) => {
                        resolve(false)
                    }, 
                    () => {
                        // Upload completed successfully, now we can get the download URL
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            resolve(downloadURL);
                        });
                    }
                );
            });

            return promise;
        } catch (error) {
            return { error, status: "failed" };
        }
    }
);

// Thunk functions for add a document to a collection
export const deleteFile = createAsyncThunk(
    "firestore/deleteFile",
    async ({ urlFile }) => {
        try {
            const storage = getStorage();
    
            // Create a reference to the file to delete
            const desertRef = ref(storage, urlFile);

            let promise = await new Promise(resolve => {
                // Delete the file
                deleteObject(desertRef).then(() => {
                    // File deleted successfully
                    resolve(true);
                }).catch((error) => {
                    // Uh-oh, an error occurred!
                    resolve(false);
                });
            });

            return promise;
        } catch (error) {
            return { error, status: "failed" };
        }
    }
);

const firestoreSlice = createSlice({
    name: "storage",
    initialState,
    reducers: {
        // reducer for get documnets of a collection in real time
    },
    extraReducers: builder => {
        builder
            // control de estado de la promesa para setFile
            .addCase(setFile.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(setFile.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.urls = [action.payload]
            })
            .addCase(setFile.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            // control de estado de la promesa para setFilePDF
            .addCase(setFilePDF.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(setFilePDF.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.urls = action.payload
            })
            .addCase(setFilePDF.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
            // control de estado de la promesa para deleteFile
            .addCase(deleteFile.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(deleteFile.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.urls = action.payload
            })
            .addCase(deleteFile.rejected, (state, action) => {
                state.status = 'failed'
                state.error = action.error.message
            })
    }
});

export default firestoreSlice.reducer;
